<div id="locationslist" class="p-4 w-full max-w-4xl mx-auto">
  <div #locationContainer id="v-scrollable" class="overflow-y-auto scroll-smooth space-y-4 bg-white shadow-lg p-4">
        <div *ngIf="locations.length > 0">
          <div 
            *ngFor="let location of locations | paginate: { itemsPerPage: pageSize, currentPage: currentPage, totalItems: count }; let i = index;"
            [attr.id]="'loc' + i" 
            (click)="showMarker(i)" 
            [ngClass]="{'border-2 border-green-500': selectedRowItem == i}" 
            class="p-4 bg-gray-100 rounded-lg shadow-sm transition-all cursor-pointer hover:bg-gray-200">
    
            <p class="text-lg font-semibold text-gray-900 mb-2">
              📍 {{ location.latitude }}, {{ location.longitude }}
            </p>
            <p class="text-sm mb-2">
              <b class="text-gray-900">Speed:</b> {{ location.speed | number : '1.2-2' }} m/s
            </p>

            <p class="text-sm mb-2">
              <b>Dist. from prev</b> {{ formateDistance(getDistanceFromPrevious(i))}}
            </p>
            <p class="text-xs text-gray-500 mb-2">
              {{ location.acquired | date:'medium' }}
            </p>
    
            <div class="text-right font-bold mb-2">
              <span *ngIf="!location.isOnline" class="text-red-500">Offline</span>
              <span *ngIf="location.isOnline" class="text-green-500">Online</span>
            </div>
          </div>
        </div>


        <pagination-controls 
        *ngIf="count > pageSize"
        class="my-pagination mt-4" 
        [autoHide]="false"
        [totalItems]="count"
        [itemsPerPage]="pageSize"
        [currentPage]="currentPage"
        (pageChange)="onPageChanged($event)">
        </pagination-controls>
  </div>

  
    
     
</div>
  